import React, { Component } from 'react';
import Style from './QuoteSection.css';

class QuoteSection extends Component {
	render() {
		const item = this.props.quoteData;
		return (
			<div style={Style.QuoteSection} className={`quote-area ` + this.props.alignItem}>
				<div className="student-quote">{item.quote}</div>
				<div className="quote-sig">
					<img src={item.quoteImg} alt={item.quoteAlt} />
					<div className="quote-author">
						<strong className="student-name">{item.quoteAuth}</strong>
						<span className="quote-major">{item.quoteMajor}</span>
					</div>
				</div>
			</div>
		);
	}
}

export default QuoteSection;
